import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaArrowRight } from 'react-icons/fa';
import { TypeAnimation } from 'react-type-animation';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <HeroContainer>
      <div className="container">
        <HeroCard>
          <HeroContent>
            <HeroInfo>
              <AnimatedHeader
                sequence={[
                  'Bartłomiej Zawadzki',
                  2000,
                  'IT Engineer',
                  2000,
                  'Fullstack Developer',
                  2000,
                  'Software Architect',
                  2000,
                ]}
                wrapper="h1"
                cursor={true}
                repeat={Infinity}
              />
              <HeroText>{t('home.intro')}</HeroText>
              <HeroButton to="/projects">
                {t('home.cta')} <FaArrowRight />
              </HeroButton>
            </HeroInfo>
          </HeroContent>
        </HeroCard>
      </div>
    </HeroContainer>
  );
};

const HeroContainer = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  color: var(--white);
  padding: 6rem 0;
  overflow: hidden;
  background-color: transparent;
`;

const HeroCard = styled.div`
  background: rgba(16, 16, 16, 0.6);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: var(--border-radius-xl);
  padding: 3rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  z-index: 1;

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

const HeroContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 2rem;
  z-index: 1;
`;

const HeroInfo = styled.div`
  flex: 1;
  max-width: 800px;
`;

const AnimatedHeader = styled(TypeAnimation)`
  font-size: 4rem;
  font-family: var(--font-heading);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  color: var(--primary-color);
  text-shadow: 0 0 15px rgba(57, 255, 20, 0.5);

  @media (max-width: 768px) {
    font-size: 3rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

const HeroText = styled.p`
  font-size: 1.25rem;
  margin-bottom: 2rem;
  opacity: 0.8;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const HeroButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: transparent;
  color: var(--primary-color);
  font-weight: 600;
  padding: 1rem 2rem;
  border-radius: var(--border-radius-md);
  transition: all var(--transition-fast) ease;
  border: 2px solid var(--primary-color);
  
  svg {
    transition: transform var(--transition-fast) ease;
  }
  
  &:hover {
    background-color: var(--primary-color);
    color: var(--black);
    box-shadow: 0 0 15px var(--primary-color);
    transform: translateY(-3px);
    
    svg {
      transform: translateX(3px);
    }
  }
`;

export default Hero;